import { strCode } from "../../consts";

const consentAttributes = [
  { id: "ACCESS_TNC", value: strCode.CONSENT_ATTRIBUTE_ACCESS_TNC },
  { id: "COLLECTING_TNC", value: strCode.CONSENT_ATTRIBUTE_COLLECTING_TNC},
  { id: "DESCRIPTION", value: strCode.CONSENT_ATTRIBUTE_DESCRIPTION }
];

export default consentAttributes;
